/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-right': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M.667 8.667h13.058l-4.196 4.196a.668.668 0 00.943.943l5.333-5.333a.67.67 0 000-.945l-5.333-5.333a.665.665 0 00-.943 0 .668.668 0 000 .943l4.196 4.196H.667a.666.666 0 100 1.333z"/>'
  }
})
